import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { Title } from "@angular/platform-browser";

import { ApiService } from "src/app/api.service";
import { FleetTrackerService } from "src/app/fleet-tracker.service";
declare const BrandVars;

@Component({
	selector: "app-fleet",
	templateUrl: "./fleet.component.html",
	styleUrls: ["./fleet.component.scss"]
})
export class FleetComponent implements OnInit, OnDestroy {
	private subscriptions: Subscription[] = [];

	constructor(private route: ActivatedRoute, private title: Title, private fleettracker: FleetTrackerService, private api: ApiService) { }

	ngOnInit() {
		// TODO: fix up someday
		/* eslint-disable-next-line @typescript-eslint/no-this-alias */
		const me = this;
		let selectedfleet: number;
		// A change in either the route parameter or the fleets collection must trigger a selection

		// Try to select fleet when route parameter is changed
		me.subscriptions.push(me.route.params.subscribe(params => {
			selectedfleet = Number(params["fleetid"]);
			me.fleettracker.SelectFleet(selectedfleet);
		}));
		// Try to select fleet when fleet list is updated
		me.subscriptions.push(me.fleettracker.fleets.subscribe(() => {
			me.fleettracker.SelectFleet(selectedfleet);
		}));
		// Change title on selected fleet change
		me.subscriptions.push(me.fleettracker.currentFleet.subscribe(newfleet => {
			if (newfleet) {
				me.title.setTitle(BrandVars.appName + " - " + newfleet.fleet_name);
			}
		}));
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) {
			sub.unsubscribe();
		}
	}
}
